const routes = {
  home: '/',
  welcome: {
    withPage: '/welcome/:page/:subpage?',
    root: '/welcome',
    finishSignup: '/welcome/finish-signup',
    success: '/welcome/success',
  },
  jobs: {
    root: '/steve',
    active: '/steve/active',
    potential: '/steve/potential',
    potentialMarkInterest: '/steve/potential/:positionId/:interest?',
  },
  application: {
    root: '/application',
  },
  signIn: '/sign-in',
  signInCallback: '/login/callback',
  signOut: '/sign-out',
  signOutCallback: '/logout/callback',
  profile: {
    root: '/profile',
    basic: {
      builder: '/profile/basic/builder',
    },
  },
  skillsAndJobs: '/your-skills-and-jobs',
} as const;

export default routes;
